import { motion } from 'framer-motion';
import { Logo } from '@/shared/components/logo';

export function AgendaScanLoader() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-6 px-4 py-16">
      <motion.div
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ repeat: Infinity, duration: 1.8, ease: 'easeInOut' }}
      >
        <Logo size={64} showWordmark={false} />
      </motion.div>

      <div className="max-w-md space-y-2 text-center">
        <p className="text-lg font-semibold tracking-tight">Montando a agenda</p>
        <p className="text-sm text-muted-foreground">
          Buscando campanhas de todas as lojas. O resultado fica em cache local por 6 horas.
        </p>
      </div>
    </div>
  );
}
